import React from "react";
import SealCheck from "../../../assets/SealCheck.svg";
import "./Tab-bar.css";

export const TabBar = ({
  activeTab,
  setActiveTab,
  completedTabs,
  domainProgress,
}) => {
  // console.log("TabBar - Received Props:", {
  //   activeTab,
  //   completedTabs,
  //   domainProgress,
  // });

  const tabs = [
    "Physical",
    "Emotional",
    "Acceptance",
    "Relationships",
    "Loving Kindness",
    "Intellectual",
  ];

  console.log("completedTabs:", completedTabs);

  return (
    <div className="tab-bar">
      {tabs.map((tab, index) => {
        const isActive = tab.toLowerCase() === activeTab;
        // const isCompleted = completedTabs ? completedTabs.includes(tab) : false; // Use the prop
        const isCompleted = completedTabs
          ? completedTabs.some((t) => t.toLowerCase() === tab.toLowerCase())
          : false;

        const currentDomainProgress =
          domainProgress && domainProgress[tab.toLowerCase()]
            ? domainProgress[tab.toLowerCase()]
            : 0;

        return (
          <React.Fragment key={tab}>
            <div
              className={`tab-item ${isActive ? "active" : ""} ${
                isCompleted ? "iscompleted" : ""
              }`}
            >
              {isCompleted && (
                <img
                  src={SealCheck}
                  alt="Completed"
                  className="check-icon-inline"
                />
              )}
              <span>{tab}</span>
            </div>
            {isActive && index < tabs.length - 1 && (
              <div className="task-progress-container">
                <div
                  className="task-progress-bar"
                  style={{ width: `${currentDomainProgress}%` }}
                />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
